export default __webpack_public_path__ + "static/media/element_55.944cd950.avif";